import {
  aClient,
  aParcelDataResidentialVisible,
  aParcelDataVisible,
  aVisibleGeographies,
  useAtom,
  useAtomValue,
  useSetAtom,
} from '~/atoms'
import { Checkbox, Label, Switch } from '~/components/ui'

export default function MapParcelDataControl() {
  const client = useAtomValue(aClient)
  const [parcelDataVisible, setParcelDataVisible] = useAtom(aParcelDataVisible)
  const [parcelDataResidentialVisible, setParcelDataResidentialVisible] =
    useAtom(aParcelDataResidentialVisible)
  const setVisibleGeographies = useSetAtom(aVisibleGeographies)

  return (
    <div className="mb-4 rounded-sm border p-4 shadow-sm">
      <div className="flex justify-between">
        <p className="overflow-ellipsis text-base">Parcel Data</p>
        <div>
          <Switch
            id="layer-parcel-data"
            checked={parcelDataVisible}
            onCheckedChange={(checked) => {
              setParcelDataVisible(checked)
              if (checked) {
                setVisibleGeographies([])
              }
            }}
          />
        </div>
      </div>
      <p className="prose text-sm">
        <strong>Zoom in</strong> to view parcel data after enabling.{' '}
        {client.layers_enabled && (
          <strong>Enabling parcel data will hide other layers.</strong>
        )}
      </p>
      <div className="mt-3 flex items-center gap-2">
        <Checkbox
          id="show-residential-parcels"
          checked={parcelDataResidentialVisible}
          onCheckedChange={(checked) =>
            setParcelDataResidentialVisible(checked.valueOf() === true)
          }
        />
        <Label htmlFor="show-residential-parcels" className="text-sm">
          Show Residential Parcels
        </Label>
      </div>
    </div>
  )
}
